<template>
  <div class="agreement-page">
    <div class="agreement-page-inner">
      <h1 class="agreement-page-title">隐私政策</h1>
      <AgreementContent type="userprivacyinfo" title="隐私政策" :is-privacy-policy="true" />
    </div>
  </div>
</template>

<script>
import AgreementContent from "@/components/AgreementContent.vue";

export default {
  name: "PrivacyPolicyPage",
  components: {
    AgreementContent,
  },
};
</script>
